
import { FormGroup, FormControl, FormArray, Validators } from '@angular/forms';
import { WorkCalculationBuildingserviceEntryDto } from '../models/work-calculation-buildingservice-entry-dto';

export function getCreateCalculationTemplateDtoFormGroup() {
return new FormGroup({
    name: new FormControl<string | undefined>('', [Validators.required, Validators.maxLength(200)]),
    description: new FormControl<string | undefined>(undefined, [Validators.maxLength(500)]),
    containertypeId: new FormControl<number | undefined>(undefined),
    active: new FormControl<boolean | undefined>(true),
    sortOrder: new FormControl<number | undefined>(undefined),
    buildingserviceEntries: new FormControl<WorkCalculationBuildingserviceEntryDto[]>([]),
})
;
}
      